var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      height: _vm.height,
      width: _vm.width,
      title: _vm.title,
      confirmText: _vm.confirmText,
      confirmClass: _vm.confirmClass,
      confirmDisabled: !_vm.showConfirm,
      closeText: _vm.closeText,
      closeClass: _vm.closeClass,
      defaultFocus: false,
    },
    on: {
      close: function close($event) {
        return _vm.$emit("close")
      },
      confirm: _vm.confirm,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "dialogContent",
          fn: function fn() {
            return [
              _c(
                "div",
                {
                  staticClass: "wizard-wrapper",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "wizard-meta",
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: _vm.activeSlot.icon,
                          size: 96,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "wizard-description",
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.activeSlot.description) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.requirements.length > 0
                        ? _c(
                            "p",
                            {
                              staticClass: "wizard-requirements",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$gettext(
                                      "Bitte geben Sie die folgenden Informationen an:"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.requirements,
                                  function (requirement, index) {
                                    return _c(
                                      "li",
                                      {
                                        key:
                                          requirement.slot.name + "_" + index,
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            on: {
                                              click: function click($event) {
                                                return _vm.selectSlot(
                                                  requirement.slot.id,
                                                  requirement.target
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("studip-icon", {
                                              attrs: {
                                                shape: requirement.slot.icon,
                                                size: 16,
                                                role: "clickable",
                                              },
                                            }),
                                            _vm._v(
                                              _vm._s(requirement.text) +
                                                "\n                            "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "wizard-content-wrapper",
                    },
                    [
                      _c("h2", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.activeSlot.title)
                        ),
                        _vm.activeSlotRequiered
                          ? _c(
                              "span",
                              {
                                staticClass: "required",
                                attrs: {
                                  "aria-hidden": "true",
                                },
                              },
                              [_vm._v("*")]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "wizard-progress",
                        },
                        _vm._l(_vm.slots, function (progress) {
                          return _c(
                            "li",
                            {
                              key: progress.id,
                              class: [
                                _vm.isValid(progress.id) ? "valid" : "invalid",
                                _vm.activeId === progress.id
                                  ? "active"
                                  : "inactive",
                                _vm.isOptional(progress.id) ? "optional" : "",
                              ],
                            },
                            [
                              _c(
                                "button",
                                {
                                  ref: "tabs",
                                  refInFor: true,
                                  attrs: {
                                    title: progress.title,
                                    role: "tab",
                                    "aria-selected":
                                      _vm.activeId === progress.id,
                                    "aria-controls": progress.name,
                                    tabindex: 0,
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.selectSlot(
                                        progress.id,
                                        progress.target
                                      )
                                    },
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "right",
                                            39,
                                            $event.key,
                                            ["Right", "ArrowRight"]
                                          )
                                        )
                                          return null
                                        if (
                                          "button" in $event &&
                                          $event.button !== 2
                                        )
                                          return null
                                        return _vm.nextContent.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "left",
                                            37,
                                            $event.key,
                                            ["Left", "ArrowLeft"]
                                          )
                                        )
                                          return null
                                        if (
                                          "button" in $event &&
                                          $event.button !== 0
                                        )
                                          return null
                                        return _vm.prevContent.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: progress.icon,
                                      size: 24,
                                      role: _vm.isValid(progress.id)
                                        ? "info_alt"
                                        : "clickable",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "wizard-list",
                        },
                        _vm._l(_vm.slots, function (slot) {
                          return _c(
                            "li",
                            {
                              key: slot.id,
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: slot.id === _vm.activeId,
                                      expression: "slot.id === activeId",
                                    },
                                  ],
                                  staticClass: "wizard-item",
                                  attrs: {
                                    role: "tabpanel",
                                    "aria-labelledby": slot.name,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "wizard-content",
                                    },
                                    [_vm._t(slot.name)],
                                    2
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "dialogButtonsBefore",
          fn: function fn() {
            return [
              _c(
                "button",
                {
                  staticClass: "button arr_left",
                  style: {
                    visibility: _vm.hasPrevContent ? "visible" : "hidden",
                  },
                  on: {
                    click: _vm.prevContent,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$gettext("zurück")) +
                      "\n        "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "dialogButtonsAfter",
          fn: function fn() {
            return [
              _c(
                "button",
                {
                  staticClass: "button arr_right",
                  style: {
                    visibility: _vm.hasNextContent ? "visible" : "hidden",
                  },
                  on: {
                    click: _vm.nextContent,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$gettext("weiter")) +
                      "\n        "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }